import { useEffect } from 'react';
import { toast } from 'react-hot-toast';

/** One id for every guard's refusal, so a refusal never stacks toasts. */
export const ROUTE_REFUSED_TOAST_ID = 'route-refused';

/**
 * Shows a route guard's permission toast when it refuses the user.
 *
 * Fired from an effect, not during render: a toast during render updates the <Toaster/> while the
 * guard renders (React warns "Cannot update a component while rendering a different component"),
 * and StrictMode's double render stacked duplicates. The fixed id dedupes StrictMode's second
 * effect run and nested guards refusing the same navigation.
 */
export function useRefusalToast(message: string, refused: boolean): void {
  useEffect(() => {
    if (refused) {
      toast.error(message, { id: ROUTE_REFUSED_TOAST_ID });
    }
  }, [message, refused]);
}
